import React, { Fragment, Component } from 'react';
import DEFINE, { FEATURE_FLAGS, PAGINATION, PATHS } from "../../../../constants/Define";
import * as Func from '../../../../helpers/functions';
import * as HMS from '../../common/component/Index';
import AutoFillList from './AutoFillList';
import { withTranslation } from 'react-i18next';
import Ripple from '../../common/component/Ripple';
import { Link } from 'react-router-dom';
import { Button } from 'antd';

let permissionActions = [];

export class AutoFill extends Component{

    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.promotionState.pageSize,
                pageIndex: this.props.promotionState.pageIndex,
            },
        }
    }

    componentDidMount() {
        permissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.AUTO_FILL);
        this.props.getListAutoFill(this.state.filters);
    }

    createMenu = ()=>{

    }

    render(){
        const { t, promotionState, getListAutoFill } = this.props;
        const { isFetchingAutoFill, autoFillPage, autoFills} = promotionState;
        const { totalCount, totalPage, pageIndex, pageSize } = autoFillPage;
        const pagination = { totalCount, totalPage, defaultCurrent: pageIndex, pageSize };

        return(
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={ FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage }>
                        <HMS.HeaderListComponent
                            path={ this.props.match.path }
                            groupPath={ 'promotions' }
                            titleHeader={ t('navigation.autoFill') }
                            componentRight={
                                <Fragment>
                                    {
                                        permissionActions && permissionActions.allowCreate &&
                                        <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                            <Link to={PATHS.AUTOFILL.CREATE.path}
                                                className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                        </Ripple>
                                    }
                                </Fragment>
                            }
                        />
                        <AutoFillList 
                            autoFills={autoFills}
                            pagination={pagination}
                            loading={isFetchingAutoFill}
                            getListAutoFill={getListAutoFill}
                        />
                    </HMS.PageListComponent>
            </Fragment>
        )
    }

    onChangeLanguage = () => {
        this.props.getListPromotions(this.state.filters)
    }

}

export default withTranslation()(AutoFill)